import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { getFullName } from "../../../SharedComponents/utils/helpers/getFullName";
import LocationPinIconSVG from "../../assets/icons/svg/LocationPinIconSVG";
import MailIconSVG from "../../assets/icons/svg/MailIconSVG";
import PhoneIconSVG from "../../assets/icons/svg/PhoneIconSVG";
import PartOfferSellerRatingVisualsator from "./PartOfferSellerRatingVisualisator";

const PartOfferSellerInfoSection = ({
    fetchedPartOffer
}) => {
    const sellerProfilePicSource = fetchedPartOffer.User.medium_profile_image_url;

    const sellerName = getFullName(fetchedPartOffer.User.firstname, fetchedPartOffer.User.lastname);
    const sellerAddress = fetchedPartOffer.User.address;
    const sellerMail = fetchedPartOffer.User.email;
    const sellerPhone = fetchedPartOffer.User.phone;


    const GetImageStack = () => {
        return (
            <div style={styles.imageContainer}>
                <img src={sellerProfilePicSource} style={styles.image} />
            </div>
        );
    };

    const GetSellerInfoStack = () => {
        return (
            <div style={styles.sellerInfoContianer}>
                <p style={styles.sellerNameText}>
                    {sellerName}
                </p>

                <div style={styles.sellerInfoItemRow}>
                    <LocationPinIconSVG />
                    <p style={styles.sellerInfoItemText}>
                        {sellerAddress}
                    </p>
                </div>

                <div style={styles.sellerInfoItemRow}>
                    <MailIconSVG />
                    <p style={styles.sellerInfoItemText}>
                        {sellerMail}
                    </p>
                </div>

                <div style={styles.sellerInfoItemRow}>
                    <PhoneIconSVG />
                    <p style={styles.sellerInfoItemText}>
                        {sellerPhone}
                    </p>
                </div>
            </div>
        );
    };


    const GetGoogleMapsStack = () => {
        const getGoogleMapsSourceString = () => {
            const baseUrl = "http://maps.google.com/maps?q=";
            const suffix = "&z=16&output=embed";

            //hardcoded for now
            const lat = 44.98502390;
            const lon = 20.52873890;

            return `${baseUrl}${lat},${lon}${suffix}`;
        };

        const styles = {
            iframeStyle: {
                border: "1px solid rgb(203, 213, 225)",
                borderRadius: 8
            }
        };

        return (
            <iframe
                style={styles.iframeStyle}
                src={getGoogleMapsSourceString()}
                height="150"
                width="320"
            />
        );
    };

    return (
        <div>
            <div style={styles.ratingAndAdressRow}>
                <PartOfferSellerRatingVisualsator
                    positiveCount={fetchedPartOffer.User.positive_rated_as_seller}
                    negativeCount={fetchedPartOffer.User.negative_rated_as_seller}
                />

                <p style={styles.addressText}>
                    {sellerAddress}
                </p>
            </div>


            <div style={styles.body}>

                {GetImageStack()}

                {GetSellerInfoStack()}

                {GetGoogleMapsStack()}

            </div>


        </div>
    );
};

export default PartOfferSellerInfoSection;

const styles = {
    mainContainer: {

    },
    ratingAndAdressRow: {
        display: 'flex',
        width: 'max-content',
        gap: 40,
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    addressText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "24px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    body: {
        marginTop: 30,
        display: 'flex',
        width: 'max-content',
        alignItems: 'center',
        gap: 20
    },
    imageContainer: {
        width: 150,
        height: 150,
        border: "1px solid #CBD5E1",
        borderRadius: 8,
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 8
    },
    sellerInfoContianer: {
        display: "flex",
        flexDirection: "column",
        gap: 10
    },
    sellerNameText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "20px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    sellerInfoItemRow: {
        display: 'flex',
        width: 'max-content',
        alignItems: 'center',
        gap: 20
    },
    sellerInfoItemText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.87)"
    }
}